import { Heading, Link } from '@apollo/orbit';
import React from 'react';

import { Code } from 'src/components/code/Code';
import { ApolloGitHubRouter } from 'src/lib/routers';

export const RouterRequirements = ({
  minimumRouterVersion,
}: {
  minimumRouterVersion: string;
}) => (
  <div>
    <Heading variant="title" className="mb-1">
      Router requirements
    </Heading>
    <div className="flex justify-between">
      <p>
        Use the command below to check the version of your Apollo Router binary.
      </p>
      <Link isExternal to={ApolloGitHubRouter.path('RouterReleases')}>
        v{minimumRouterVersion} or higher
      </Link>
    </div>
    <Code className="mt-2 text-sm" code="./router --version" showCopyButton />
  </div>
);
